module.exports = __webpack_public_path__ + "img/upload-guideline.569c9df9.jpg";